<template>
<div>
  <div class="d-flex" id="wrapper">
    <SideBar />
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-primary mb-0 hover-cursor">&nbsp; Assembly</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
              <h5 class="card-title mt-3 mb-5">Perbaikan Unit</h5>
            </div>
            <div class="container">
              <div class="row align-items-start my-2">
                <div class="col-lg-2 mt-2">
                  SC/SN
                </div>
                <div class="col-lg-10 pl-0">
                  <input type="text" v-model="snsc" class="form-control" v-on:keyup.enter="doSearchSn">
                  <div class="col-lg-12 px-0 my-2" v-if="itemChoose">
                    <div>{{itemChoose.itemGroup}} - {{itemChoose.itemName}}</div>
                    <div>{{itemChoose.stockCode}}/{{itemChoose.serialNumber}} ({{itemChoose.status}})</div>
                    <div v-for="(item,i) in itemChoose.bomItem" :key="`choosen-${i}`">
                      <div v-for="(jml,index) in item.itemQty" :key="`choosenItem${i}-${index}`">
                        {{item.itemName}}
                      </div>
                    </div>
                    <div>Kategori Kerusakan: -</div>
                  </div>
                  <div v-if="itemChoose.dataTicket">
                    <div class="col-lg-12 py-2 component-border rounded my-2" v-for="(ticket,i) in itemChoose.dataTicket" :key="`choosedDataTicketItem-${i}`">
                      <div>{{ticket.ticketNo}}</div>
                      <div>Tgl Perbaikan : {{ticket.repairedTime}}</div>
                    </div>
                  </div>
                  <div class="mt-4" v-if="itemChoose">Masukkan nama part yang rusak</div>
                  <!-- <input type="text" v-model="part" class="form-control" v-if="itemChoose"> -->
                  <!-- <multiselect v-if="itemChoose" v-model="part" :options="partRusak" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Pilih Part" label="itemName"></multiselect> -->
                  <Autocomplete v-if="itemChoose" :search="search" :get-result-value="getResultValue" @submit="handleSubmit" placeholder="Masukkan nama part" style="width: 100%; margin-right: 1%; list-style-type: none;" base-class="asani-search"></Autocomplete>
                  <div class="container my-2" v-if="perbaikan.length > 0">
                    <div class="row align-items-center justify-content-between" v-for="(part,i) in perbaikan" :key="`brokenPart-${i}`">
                      <div class="col-lg-11 py-2 mt-1 component-border rounded d-flex align-items-center">
                        <input type="checkbox" class="mr-2" v-model="part.isReturn">
                        <div>{{part.itemName}}</div>
                        <!-- <div>SC100001/SN100123</div> -->
                      </div>
                      <button class="btn btn-danger py-1 px-3 mr-3 font-weight-bold" @click="removePerbaikan(part)">-</button>
                    </div>
                    <div class="text-muted small mt-1"><i class="fas fa-info-circle"></i> Centang jika part rusak disimpan ke gudang. Uncheck jika part diperbaiki/dipakai kembali.</div>
                  </div>
                  <div class="mt-4" v-if="itemChoose">Part yang digunakan dalam perbaikan</div>
                  <div v-if="itemChoose && perbaikan.length > 0">
                    <div :class="item.hasBatchNo ? 'part-used-card mt-2' : 'col-lg-12 mt-3'" v-for="(item,i) in perbaikan" :key="`usedPart-${i}`">
                      <div class="part-used-name">{{ item.itemName }}</div>
                      <multiselect
                        v-if="item.hasBatchNo"
                        v-model="item.inputBatchNo"
                        :options="item.batchOptions || []"
                        :allow-empty="false"
                        :select-label="''"
                        :deselect-label="''"
                        placeholder="Pilih Nomor Batch"
                        label="batchNumber"
                        track-by="batchNumber"
                        @open="getBatchList(item, i)">
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-right my-5">
                <button class="btn btn-primary py-2 px-3" :disabled="!itemChoose" @click="doRepair">Selesai Diperbaiki</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal select bom -->
      <div class="modal fade" id="modalSelectBom" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <!-- Modal Content -->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Pilih BOM</h4>
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body py-3">
              <div class="col-lg-12 component-border bom-selection rounded my-2" v-for="(itembom,i) in selectBom" :key="`bomSelection-${i}`" @click="setBom(itembom)">
                <div v-for="(comp,index) in itembom.items" :key="`selectedItemBom${i}-${index}`">
                  {{comp}}
                </div>
              </div>
              <div class="col-lg-12 py-3"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal Notif -->
      <div class="modal fade" id="modalNotifAssembly" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <!-- Modal Content -->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <!-- <h4 class="modal-title">Pilih BOM</h4> -->
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body py-3">

              <div class="col-lg-12 py-3"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal Warehouse -->
      <div class="modal fade" id="modalWarehouse" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <!-- Modal Content -->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Warehouse Tujuan</h4>
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body py-3">
              <div class="col-lg-12 py-3">
                <div class="mb-2">Pilih warehouse tujuan untuk unit yang diperbaiki</div>
                <multiselect class="mb-2" v-model="warehouse" :options="selectWarehouse" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Pilih Warehouse"></multiselect>
              </div>
            </div>
            <div class="modal-footer">
              <div class="col-lg-12">
                <div class="container">
                  <div class="row justify-content-end">
                    <button class="mr-1 btn btn-danger" data-dismiss="modal">Batal</button>
                    <button class="btn btn-primary" @click="confirmSave" :disabled="warehouse == ''" v-if="!loadingBtnSave">Simpan</button>
                    <button type="button" class="btn btn-primary" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Loading</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import SideBar from '../SideBar.vue';

export default {
  name: 'ChangeSpecPage',
  components: {
    Multiselect,
    SideBar
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      permission: [],
      admin: '',
      adminId: '',
      warehouse: '',
      perakitan: '',
      itemChoose: '',
      type: '',
      snsc: '',
      bom: '',
      partRusak: [],
      partPerbaikan: [],
      part: '',
      perbaikan: [],
      selectBom: [{ bomCode: 1, items: ['Lenovo Test 1 i7', 'RAM DDR4 4GB', 'RAM DDR4 4GB'] }, { bomCode: 2, items: ['Lenovo Test 2 i7', 'RAM DDR4 4GB', 'RAM DDR4 4GB'] }],
      selectWarehouse: ['Warehouse 1', 'Warehouse 2'],
      selectPerakitan: ['Upgrade / Downgrade (Full Part)', 'Lepas Part'],
      selectType: ['Laptop', 'CPU'],
      selectItem: ['Lenovo Thinkpad T460 i7/8GB RAM/SSD 256GB/NVIDIA GEFORCE 940M', 'DELL VOSTRO 1450 i5/8GB RAM/HDD 500GB/AMD GRAPHIC'],
      loadingBtnSave: false,
    }
  },
  methods: {
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    openModalBom() {
      $("#modalSelectBom").modal("show")
    },
    toPage(e) {
      this.$router.push(e)
    },
    setBom(item) {
      this.bom = item
      $("#modalSelectBom").modal("hide")
    },
    getBatchList(item, index) {
       if (item.batchOptions && item.batchOptions.length > 0) return // sudah diload

      this.$http.post(process.env.ASSEMBLY_GET_BATCH_BY_ITEM_CODE, {
        itemCode: item.itemCode,
        warehouse: this.itemChoose.warehouse.replace('Trouble', 'Repair'),
      }, {
        headers: {
          'Asani-Token': localStorage.getItem('jwt')
        }
      })
      .then(response => {
        if (response.data.status == 200) {
          this.$set(this.perbaikan[index], 'batchOptions', response.data.data)
          // this.itemChoose = res.data.content
          // this.warehouse = res.data.content.warehouse
          // this.searchPart()
        } else {
          swal('Error', res.data.message, 'error')
        }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    doSearchSn() {
      this.$http.post(process.env.ASSEMBLY_SEARCH_SN_TROUBLE, {
        scsn: this.snsc.replace(this.spaceRegex, ' ')
      }, {
        headers: {
          'Asani-Token': localStorage.getItem('jwt')
        }
      }).then(res => {
        if (res.data.status == 200) {
          this.itemChoose = res.data.content
          this.warehouse = res.data.content.warehouse
          this.searchPart()
        } else {
          swal('Error', res.data.message, 'error')
        }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    removePerbaikan(part) {
      let newpart = []
      this.perbaikan.forEach(el => {
        if (el !== part) {
          newpart.push(el)
        }
      })
      this.perbaikan = newpart
    },
    resetData() {
      this.part = '',
      this.partRusak = []
      this.partPerbaikan = []
      this.perbaikan = []
      this.snsc = ''
      this.itemChoose = ''
    },
    search(value) {
      this.part = value
      return new Promise((resolve, reject) => {
        if (value.length < 3) return resolve([])
        if(value.length > 2) {
          this.$http.post(process.env.ASSEMBLY_SEARCH_PART, {
              name: value,
              warehouse: this.warehouse
            }, {
              headers: {
                'Asani-Token': localStorage.getItem('jwt')
              }
            })
            .then((res) => {
              if (res.status == 200) {
                resolve(res.data.content)
              } else {
                resolve(value)
              }
            })
            .catch(error => {
              swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
              }).then(v => {
                reject(error)
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              })
            })
        }
      })
    },
    getResultValue(value) {
      return value.itemName
    },
    handleSubmit(result) {
      if (result) {
        this.perbaikan.push({...result, inputBatchNo:'', batchOptions:[], isReturn: true})
        console.log(result)
      }
    },
    saveSearch(e) {
      this.perbaikan.push(e)
    },
    searchPart() {
      this.$http.post(process.env.ASSEMBLY_SEARCH_PART, {
          name: this.itemChoose.itemName,
          warehouse: this.warehouse
        }, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(res => {
          if (res.data.status = 200) {
            this.partRusak = res.data.content
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    doRepair() {
      const missingBatch = this.perbaikan.filter(item => item.hasBatchNo && !item.inputBatchNo)
      if (missingBatch.length > 0) {
        const names = missingBatch.map(item => item.itemName).join(', ')
        swal('Error', `Nomor batch belum diisi untuk: ${names}`, 'error')
        return
      }
      // this.warehouse = ''
      this.getWarehouse()
    },
    confirmSave() {
      this.loadingBtnSave = true
      let repairSelect = []
      this.perbaikan.forEach(el => {
        const {itemCode, itemName,itemGroup, itemQty, itemUom, hasBatchNo, isReturn} = el
        repairSelect.push({
          itemCode,
          itemName,
          itemGroup,
          itemQty,
          itemUom,
          hasBatchNo,
          inputBatchNo : el.inputBatchNo.batchNumber,
          isReturn
        })
      })

      this.$http.post(process.env.ASSEMBLY_SAVE_REPAIR, {
          data: this.itemChoose,
          warehouseNT: this.warehouse,
          partRepair: repairSelect,
          id: this.itemChoose.id
        }, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            swal('Success', 'Berhasil Diperbaiki', 'success')
            this.loadingBtnSave = false
            this.resetData()
            $('#modalWarehouse').modal('hide')
          } else {
            swal('Error', res.data.message, 'error')
            this.loadingBtnSave = false
            $('#modalWarehouse').modal('hide')
          }
        })
        .catch(error => {
          this.loadingBtnSave = false
          $('#modalWarehouse').modal('hide')
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    getWarehouse() {
      this.$http.post(process.env.GET_WAREHOUSE_READY_STOCK,{
        warehouse : this.warehouse
      },{
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(res => {
          this.selectWarehouse = res.data.content
          $('#modalWarehouse').modal('show')
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
      if (this.viewEmployee == false) {
        this.$router.push('/')
      }
    },
  },
  watch: {
    // part: {
    //   handler: function () {
    //     if (this.part !== '') {
    //       this.perbaikan.push(this.part)
    //       this.part = ''
    //       console.log(this.perbaikan)
    //     }
    //   }
    // }
  },
  created() {
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.cekLogin()
    this.cekPermission()
    // this.searchPart()
  }
}
</script>

<style>
/* Card wrapper per item part */
.part-used-card {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 10px;
  background-color: #ffffff;
}
/* Nama part (baris atas, bold/semibold) */
.part-used-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: #343a40;
  background-color: #e9ecef;
  border-radius: 4px 4px 0 0;
  padding: 8px 12px;
  margin: -12px -14px 10px -14px; /* bleed ke tepi card */
}
/* Styling multiselect agar mirip dropdown di gambar */
.part-used-card .multiselect__tags {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  min-height: 38px;
  padding: 6px 40px 6px 10px;
  background-color: #ffffff;
  font-size: 0.875rem;
}

.part-used-card .multiselect__select {
  height: 38px;
}

.part-used-card .multiselect__placeholder {
  color: #6c757d;
  font-size: 0.875rem;
  margin-bottom: 0;
  padding-top: 0;
}

.part-used-card .multiselect__single {
  font-size: 0.875rem;
  color: #343a40;
  margin-bottom: 0;
}

.part-used-card .multiselect__input {
  font-size: 0.875rem;
}
.component-border {
  border: 1px solid rgb(206, 212, 218);
  background-color: rgb(233, 236, 239);
}

.bom-selection {
  cursor: pointer;
}

.asani-search input {
  font-size: .9rem;
}

.asani-search-desktop input {
  font-size: 12px;
  height: 50%;
}

.menu-link {
  text-decoration: none;
  color: #00023b;
}

.menu-link:active {
  text-decoration: none;
  color: #00023b;
}

.menu-link:hover {
  text-decoration: none;
  color: #00023b;
}

.btn-account {
  font-size: 16px;
}

.navbar-collapse-button:focus {
  border: none;
  outline: none !important;
}

.navbar-collapse-button:after {
  border: none;
  outline: none !important;
}
.asani-search-input {
  border: 1px solid #eee;
  border-radius: 8px;
  width: 100%;
  padding: 6px 12px 6px 40px;
  box-sizing: border-box;
  position: relative;
  font-size: 12px;
  line-height: 1.5;
  flex: 1;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+);
  background-repeat: no-repeat;
  background-position: 12px;
}
.asani-search-input:focus,
.asani-search-input[aria-expanded=true] {
  border-color: rgba(0, 0, 0, .12);
  background-color: #fff;
  outline: 0;
}
[data-position=below] .asani-search-input[aria-expanded=true] {
  border-bottom-color: transparent;
  border-radius: 8px 8px 0 0;
}
[data-position=above] .asani-search-input[aria-expanded=true] {
  border-top-color: transparent;
  border-radius: 0 0 8px 8px;
  z-index: 2;
}
.asani-search[data-loading=true]:after {
  content: "";
  border: 3px solid rgba(0, 0, 0, .12);
  border-right-color: rgba(0, 0, 0, .48);
  border-radius: 100%;
  width: 20px;
  height: 20px;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  animation: rotate 1s linear infinite;
}
.asani-search-result-list {
  margin: 0;
  border: 1px solid rgba(0, 0, 0, .12);
  padding: 0;
  box-sizing: border-box;
  max-height: 296px;
  overflow-y: auto;
  background: #fff;
  list-style: none;
}
[data-position=below] .asani-search-result-list {
  margin-top: -1px;
  border-top-color: transparent;
  border-radius: 0 0 8px 8px;
  padding-bottom: 8px;
}
[data-position=above] .asani-search-result-list {
  margin-bottom: -1px;
  border-bottom-color: transparent;
  border-radius: 8px 8px 0 0;
  padding-top: 8px;
}
.asani-search-result {
  cursor: default;
  padding: 12px 12px 12px 48px;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2NjIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+);
  background-repeat: no-repeat;
  background-position: 12px;
  width: 80%;
}
.asani-search-result:hover,
.asani-search-result[aria-selected=true] {
  background-color: none;
}
.menu-toggler:focus {
  outline: none;
  background: none;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Assembly/PerbaikanUnitPage.vue